<template>
  <div id="app" class="site-modern" v-cloak>
    <site-header></site-header>
    <div class="site-content-wrapper">
      <router-view />
    </div>
    <site-footer></site-footer>
  </div>
</template>
<script>
import "@/assets/css/global.css";

export default {
  components: {
    siteHeader: () => import("@/components/Header"),
    siteFooter: () => import("@/components/Footer")
  },
  mounted() {
    let srcLan = this.$i18n.locale;
    if (srcLan.indexOf('en') != -1) {
      srcLan = 'en';
    } else {
      srcLan = 'zh';
    }

    // if (window.location.href.indexOf('mltcloud.com') != -1) {
    //   srcLan += '_ml';
    // }
     srcLan += '_ml';
    this.$i18n.locale = srcLan;
    this.$forceUpdate();
  },
};
</script>

<style lang="stylus">
[v-cloak] {
  display: none;
}

.site-modern {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.site-content-wrapper {
  flex: 1;
}

* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111c39;
  background: #f6f8fc;
  overflow-x: hidden;
}

html {
  scroll-behavior: smooth;
}

::selection {
  color: #fff;
  background: #2459d5;
}

/* Shared presentation for legacy product-detail canvases. */
.site-content-wrapper .product-wrap {
  margin-top: 0 !important;
  padding: 44px 24px 72px;
  background: #eef2f8 !important;
}

.site-content-wrapper .product-wrap .outer {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #e0e6f0;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 22px 60px rgba(27, 46, 94, 0.1);
}

.site-content-wrapper .product-wrap .content {
  width: 100% !important;
}

.site-content-wrapper .product-wrap .content img,
.site-content-wrapper .product-wrap .content video {
  display: block;
  width: 100% !important;
  max-width: 1120px !important;
  height: auto;
  margin: 0 auto !important;
}

@media (max-width: 640px) {
  .site-content-wrapper .product-wrap {
    padding: 20px 12px 46px;
  }

  .site-content-wrapper .product-wrap .outer {
    border-radius: 16px;
  }
}
</style>
